import constants from '../constants/index';
import normalize from '../lib/normalize';

const defaultState = normalize(
	{ layersMenuOpen: false}, [
	{id: 'teachers', name: 'Staff', imgSrc: require('../../../img/svg/nav_menu_teachers.svg'), height: 16, width: 16},
	{id: 'cohorts', name: 'Students', imgSrc: require('../../../img/svg/nav_menu_students.svg'), height: 16, width: 19}
]);

export default function scheduleControlsReducer(state = defaultState, action) {
	let newState = state;

	let menuItem;

	switch(action.type) {
		case constants.SELECT_LAYERS_MENU_ITEM:
			newState = Object.assign({}, newState, {
				layersMenuOpen: action.payload.selected
			});
			break;
		case constants.SELECT_CONTROLS_MENU_ITEM:
			menuItem = action.payload.selected ? [action.payload.id] : [];
			newState = Object.assign({}, newState, {
				selected: menuItem
			});
			break;
		case constants.HIDE_OPEN_TRAYS:
			newState = Object.assign({}, newState, {
				selected: [],
				layersMenuOpen: false
			});
			break;
		
		default:
	}
	return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/schedule_controls_reducer.js
 **/